module.exports = __webpack_public_path__ + "static/media/tutorial-start-step2.cffb86c7.png";